import React from 'react';

/**
 * ローディングスピナーコンポーネント
 * @description 処理中のインジケーターを表示するコンポーネント
 */
export const LoadingSpinner: React.FC = () => (
    <div className="fixed top-0 left-0 w-full h-full flex items-center justify-center bg-black bg-opacity-50 z-50 backdrop-filter backdrop-blur-sm">
        <div className="bg-white p-8 rounded-lg shadow-xl flex flex-col items-center">
            <div className="animate-spin rounded-full h-16 w-16 border-b-4 border-blue-600"></div>
            <div className="mt-4 text-gray-700 font-medium">処理中...</div>
        </div>
    </div>
);

export default LoadingSpinner;